// Action Types
export const SET_KEYSTONE_TEAM_HISTORY = 'SET_KEYSTONE_TEAM_HISTORY';
export const SHOW_KEYSTONE_TEAM_HISTORY_LOADING_SPINNER = 'SHOW_KEYSTONE_TEAM_HISTORY_LOADING_SPINNER';

// Action Creator
const KeystoneTeamHistoryActionCreator = {
  setKeystoneTeamHistory(history: any) {
    return {
      type: SET_KEYSTONE_TEAM_HISTORY,
      payload: history
    };
  },

  showLoadingSpinner(show: boolean) {
    return {
      type: SHOW_KEYSTONE_TEAM_HISTORY_LOADING_SPINNER,
      payload: show
    };
  }
};

export default KeystoneTeamHistoryActionCreator;
